import {
  Card,
  Text,
  Title3,
  makeStyles,
  tokens,
} from "@fluentui/react-components";
import { Building24Regular } from "@fluentui/react-icons";
import type { Company } from "@/types";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "24px",
    gap: "16px",
  },
  title: {
    marginTop: "16px",
  },
  subtitle: {
    color: tokens.colorNeutralForeground3,
    marginBottom: "8px",
  },
  card: {
    width: "100%",
    cursor: "pointer",
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  icon: {
    width: "36px",
    height: "36px",
    borderRadius: "8px",
    backgroundColor: tokens.colorBrandBackground2,
    color: tokens.colorBrandForeground1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  companyName: {
    fontWeight: 600,
  },
});

interface CompanyPickerProps {
  companies: Company[];
  onSelect: (company: Company) => void;
}

export function CompanyPicker({ companies, onSelect }: CompanyPickerProps) {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Title3 className={styles.title}>Select Organization</Title3>
      <Text className={styles.subtitle} size={200}>
        Choose which organization to work with
      </Text>

      {companies.map((company) => (
        <Card
          key={company.id}
          className={styles.card}
          onClick={() => onSelect(company)}
        >
          <div className={styles.icon}>
            <Building24Regular />
          </div>
          <Text className={styles.companyName}>{company.name}</Text>
        </Card>
      ))}
    </div>
  );
}
